<script setup lang="ts">
const el = ref()
const v = useElementVisibility(el)
</script>

<template>
  <div ref="el" relative h-850px w-full lg:h-496px>
    <img absolute inset-0 object-cover size-full class="zoom" src="/images/image-1416.webp">
    <svg
      :class="v && 'animated-fade-in-left'"
      absolute animated
      lt-lg="bottom-0 left-[clamp(-10000px,calc((100vw-1920px)/5+0px),0px)]"
      class="left-[clamp(-10000px,calc((100vw-1920px)/2.5+0px),0px)]" xmlns="http://www.w3.org/2000/svg" width="530" height="496" viewBox="0 0 530 496" fill="none"
    >
      <path d="M0 496H529.5L187 0H0V496Z" fill="#CE0000" />
    </svg>
    <svg
      :class="v && 'animated-fade-in-right'"
      absolute animated lt-md:hidden
      lt-lg="right-[clamp(-10000px,calc((100vw-1920px)/1.15+0px),0px)]"
      class="right-[clamp(-10000px,calc((100vw-1920px)/1.5+0px),0px)]" xmlns="http://www.w3.org/2000/svg" width="1131" height="496" viewBox="0 0 1131 496" fill="none"
    >
      <path d="M1131 0H0L342.5 496H1131V0Z" fill="#CE0000" />
    </svg>

    <svg
      :class="v && 'animated-fade-in-right'"
      absolute animated md:hidden
      class="right-[clamp(-10000px,calc((100vw-1920px)/1.7+0px),0px)]" xmlns="http://www.w3.org/2000/svg" width="1131" height="600" viewBox="0 0 1131 600" fill="none"
    >
      <path d="M1131 0H0L442.5 600H1131V0Z" fill="#CE0000" />
    </svg>

    <div absolute inset-0 container col items-center justify-center lg:row lg:justify-end>
      <div max-w-330px lg:max-w-480px>
        <p class="text-35px font-bold lh-100% lg:text-80px" :class="v && 'animated-fade-in-right'" animated animated-delay-200>
          NOMINATE
        </p>
        <p :class="v && 'animated-fade-in-right'" mt-20px text-24px font-bold animated animated-delay-300 lg:text-53px>
          STEP 3
        </p>
        <p :class="v && 'animated-fade-in-right'" fond-bold text-15px animated animated-delay-400 lg:text-24px>
          Choose your favorite from the roster of 1,500 Miss W ambassadors.
        </p>
      </div>

      <img class="scale-0" :class="v && 'animated-fade-in-down'" src="/images/group-1000002738-prod.webp" w-353px animated animated-delay-200 lg:ml-12 lt-lg:mt-20px>
    </div>
  </div>
</template>

<style scoped lang="scss">
@keyframes zoom {
  from {
    object-position: 0% center;
  }
  to {
    object-position: 100% center;
  }
}

img.zoom {
  animation: zoom ease-in-out 20s alternate infinite;
}
</style>
